import { useState } from "react";

import { Form, Input, Checkbox, Button, Select } from "antd";
import i18next from "i18next";

import { useNavigate } from "react-router-dom";

import OAuthBox from "./OAuthBox";

import { withNamespaces } from "react-i18next";

import { countriesAr, countriesEn } from "../../constants/countries";
import { toast } from "react-toastify";

const { Option } = Select;

const { Item } = Form;
const { language } = i18next;
const { Group } = Checkbox;

const RegisterForm = ({ t, setFormType, registerType }) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    country: "",
    dataOfBirth: "",
    password: "",
    confirmPassword: "",
  });

  const {
    fullName,
    email,
    phoneNumber,
    dataOfBirth,
    password,
    confirmPassword,
  } = formData;

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = (data) => {
    console.log({ formData: data });
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    const newUserData = { ...data, registerType };
    localStorage.setItem("user", JSON.stringify(newUserData));
    navigate("/");
  };
  return (
    <>
      <Form
        name="normal_login"
        className="login-form"
        initialValues={{ remember: true }}
        onFinish={onSubmit}
        style={{ width: "70%", height: "70%" }}
      >
        <Item
          name="fullName"
          rules={[
            {
              required: true,
              message: "Please input your full name !",
            },
          ]}
        >
          <Input
            placeholder={t("pages.auth.fullName")}
            value={fullName}
            onChange={onChange}
            name="fullName"
            size="large"
          />
        </Item>

        <Item
          name="email"
          rules={[
            {
              required: true,
              message: "Please input your email !",
            },
          ]}
        >
          <Input
            placeholder={t("pages.auth.email")}
            value={email}
            onChange={onChange}
            name="email"
            size="large"
            type="email"
          />
        </Item>
        <Item
          name="phoneNumber"
          rules={[
            {
              required: true,
              message: "Please input your phone number !",
            },
          ]}
        >
          <Input
            placeholder={t("pages.auth.phoneNumber")}
            value={phoneNumber}
            onChange={onChange}
            name="phoneNumber"
            size="large"
          />
        </Item>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Item
            name="country"
            rules={[
              {
                required: true,
                message: "Please input your country !",
              },
            ]}
            style={{ width: "45%" }}
          >
            <Select
              placeholder={t("pages.auth.country")}
              title="title here"
              size="large"
            >
              {language === "en"
                ? countriesEn.map((country) => (
                    <Option
                      key={country.id}
                      value={country.id}
                      onChange={onChange}
                    >
                      {country.name}
                    </Option>
                  ))
                : countriesAr.map((country) => (
                    <Option
                      key={country.id}
                      value={country.id}
                      onChange={onChange}
                    >
                      {country.name}
                    </Option>
                  ))}
            </Select>
          </Item>
          <Item
            name="dataOfBirth"
            rules={[
              {
                required: true,
                message: "Please input your data of birth !",
              },
            ]}
            style={{ width: "45%" }}
          >
            <Input
              placeholder="Data of Birth"
              value={dataOfBirth}
              onChange={onChange}
              name="dataOfBirth"
              size="large"
              type="date"
            />
          </Item>
        </div>
        <Item
          name="password"
          rules={[
            {
              required: true,
              message: "Please input your password !",
            },
          ]}
        >
          <Input
            placeholder={t("pages.auth.password")}
            value={password}
            onChange={onChange}
            name="password"
            size="large"
            type="password"
          />
        </Item>
        <Item
          name="confirmPassword"
          rules={[
            {
              required: true,
              message: "Please input your password !",
            },
          ]}
        >
          <Input
            placeholder={t("pages.auth.confirmPassword")}
            value={confirmPassword}
            onChange={onChange}
            name="confirmPassword"
            size="large"
            type="password"
          />
        </Item>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Form.Item name="remember" valuePropName="checked">
            <Checkbox>{t("pages.auth.rememberMe")}</Checkbox>
          </Form.Item>
          <Button
            type="link"
            onClick={() => {
              navigate("/auth/forgot-password");
              setFormType("forgot-passowrd");
            }}
          >
            {t("pages.auth.forgotPassword")}
          </Button>
        </div>
        {registerType === "translator" ? (
          <>
            <div
              style={{
                backgroundColor: "#FFFFFF",
                padding: "0.5rem",
                borderRadius: "5px",
                border: "1px solid #E8E8E8",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h3
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "17px",
                    color: "#2D3748",
                  }}
                >
                  {t("pages.auth.useCases.title")}
                </h3>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    lineHeight: "15px",
                    color: "rgba(1, 47, 107, 0.63);",
                  }}
                >
                  {t("pages.auth.useCases.note")}
                  {/* Note: Only two can be selected */}
                </p>
              </div>

              <Item>
                <Group
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  options={[
                    {
                      label: t("pages.auth.useCases.cases.0"),
                      value: "Legal Translation",
                      style: {
                        color: "rgba(45, 55, 72, 0.56)",
                        width: "47%",
                        fontSize: "11px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      },
                    },
                    {
                      label: t("pages.auth.useCases.cases.1"),
                      value: "Technical Translation",
                      style: {
                        color: "rgba(45, 55, 72, 0.56)",
                        width: "47%",
                        fontSize: "11px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      },
                    },
                    {
                      label: t("pages.auth.useCases.cases.2"),
                      value: "Financial Translation",
                      style: {
                        color: "rgba(45, 55, 72, 0.56)",
                        width: "47%",
                        fontSize: "11px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      },
                    },
                    {
                      label: t("pages.auth.useCases.cases.3"),
                      value: "Website Translation",
                      style: {
                        color: "rgba(45, 55, 72, 0.56)",
                        width: "47%",
                        fontSize: "11px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      },
                    },
                    {
                      label: t("pages.auth.useCases.cases.4"),
                      value: "Document translation",
                      style: {
                        color: "rgba(45, 55, 72, 0.56)",
                        width: "47%",
                        fontSize: "11px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      },
                    },
                    {
                      label: t("pages.auth.useCases.cases.5"),
                      value: "Document translation",
                      style: {
                        color: "rgba(45, 55, 72, 0.56)",
                        width: "47%",
                        fontSize: "11px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      },
                    },
                  ]}
                  onChange={(checkedValues) => {
                    console.log("checked = ", checkedValues);
                  }}
                />
              </Item>
            </div>
          </>
        ) : null}
        <Button
          type="primary"
          htmlType="submit"
          style={{
            width: "100%",
            fontWeight: "700",
            fontSize: "16px",
            backgroundColor: "#012F6B",
            borderRadius: "5px",
            border: "none",
          }}
          size="large"
        >
          {t("pages.auth.registerNow")}
        </Button>
        <OAuthBox />
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span>{t("pages.auth.alreadyHaveAccount")}</span>
          <Button
            type="link"
            onClick={() => {
              navigate("/auth/login");
              setFormType("login");
            }}
          >
            {t("pages.auth.loginNow")}
          </Button>
        </div>
      </Form>
    </>
  );
};

export default withNamespaces()(RegisterForm);
/*

*/
